import gql from 'graphql-tag'

const query = gql`
    query getPastSearches {
        pastSearches @client {
            displayName
            searchName
            filterName
        }
    }
`
export default query
